import React, { useEffect, useRef, useState } from 'react';
import { ContentContainer } from '../../CommunityPage/MainContent/styled';
import {
  TextBox,
  TextCardActions,
  TextCardAnswer,
  TextCardTitle,
  TextCardWrapper,
} from '../../CommunityPage/TextCard/styled';
import { CategoryAns, CategoryTitle, Flex, Image } from './styled';
import { ButtonWrapper, VermButton } from '../../HomePage/Articles/styled';
import { getString, removeDefaultParams } from '../../../Utils/helper';
import { downloadAppHandler } from '../../../Utils/redirections';
import useSWR from 'swr';
import { getFeedsData } from '../../../datafetchers/HomePage';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { images } from '../../../Constants/ImageUrls';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { fireClickedCardEvent } from '../../../Utils/useFirebase';

export default function CategoryUserFeed(props) {
  const { itemsArray, tagId, hideMargin } = props;
  const [page, setPage] = useState(2);
  const [showLoadMore, setShowLoadMore] = useState(false);
  const updatedData = useRef(itemsArray);
  const { data, error, mutate } = useSWR(
    `community_category_${tagId}`,
    () => {
      // console.log("");
    },
    {
      fallbackData: itemsArray,
      revalidateOnFocus: false,
      revalidateOnMount: false,
      revalidateOnReconnect: false,
    },
  );
  const router = useRouter();
  useEffect(() => {
    setPage(2);
    setShowLoadMore(false);
    updatedData.current = itemsArray;
  }, [itemsArray]);
  useEffect(() => {
    getFeedsData({
      tag: tagId,
      page: page,
      type: 'featured',
      shortenFeedResponse: true,
    }).then((response) => {
      const responseItems = response?.data?.posts?.items;
      if (responseItems.length > 0) {
        setShowLoadMore(true);
        updatedData.current = [...updatedData.current, ...responseItems];
      } else {
        setShowLoadMore(false);
      }
    });
  }, [page]);

  const loadMoreHandler = () => {
    mutate(updatedData.current, false);
    setPage(page + 1);
  };

  return (
    <>
      <ContentContainer category hideMargin={hideMargin}>
        {data?.map((item, index) => {
          if (
            item?.contentType == 'Question' ||
            item?.contentType == 'Article'
          ) {
            return (
              <Link
                href={{
                  pathname: item?.content?.web_url,
                  query: removeDefaultParams(router.query),
                }}
                passHref
                key={index}
                locale={false}
              >
                <TextCardWrapper
                  key={`categorylist${index}`}
                  className="textBox"
                  onClick={() =>
                    fireClickedCardEvent(
                      '',
                      item?.content?.title,
                      item?.contentType == 'Question'
                        ? 'question_detail_page'
                        : 'article_detail_page',
                      item?.content?.id,
                    )
                  }
                >
                  <TextBox>
                    <TextCardTitle>
                      {getString(
                        item?.content?.propertytags?.weekPreg,
                      ).toUpperCase()}
                    </TextCardTitle>
                    <Flex>
                      <div>
                        <CategoryTitle>{item?.content?.title}</CategoryTitle>
                        <CategoryAns
                          maxW={
                            item?.content?.files?.[0]?.imageUrl
                              ? '200px'
                              : '360px'
                          }
                          dangerouslySetInnerHTML={{
                            __html:
                              item?.content_type == '4'
                                ? item?.content?.message
                                : item?.content?.body,
                          }}
                        ></CategoryAns>
                      </div>
                      {item?.content?.main_img && (
                        <Image
                          src={item?.content?.files?.[0]?.imageUrl}
                          alt=""
                        />
                      )}
                    </Flex>
                    <TextCardActions>
                      {item.contentType == 'Question' ? (
                        <TextCardAnswer onClick={downloadAppHandler}>
                          <span>FOLLOW</span>
                        </TextCardAnswer>
                      ) : (
                        <div></div>
                      )}
                      <TextCardAnswer
                        onClick={() =>
                          router.push(
                            item?.content?.web_url + window?.location?.search,
                            '',
                            {
                              locale: getRouterLocale(router),
                            },
                          )
                        }
                      >
                        <img src={images.comment} alt="" />
                        <span>{item?.content?.comments}</span>
                        <span>
                          {item.contentType == 'Question'
                            ? 'Answers'
                            : 'Comments'}
                        </span>
                      </TextCardAnswer>
                    </TextCardActions>
                  </TextBox>
                </TextCardWrapper>
              </Link>
            );
          }
        })}
      </ContentContainer>
      {showLoadMore && (
        <ButtonWrapper>
          <VermButton lg onClick={loadMoreHandler}>
            Load More
          </VermButton>
        </ButtonWrapper>
      )}
    </>
  );
}
